import { createFileRoute, redirect } from "@tanstack/react-router";

// /patio-canopy was merged into /pergola-covers (combined Patio, Gazebo &
// Pergola Covers page). Keep the URL as a 301 redirect so existing links and
// SERP results don't 404.
export const Route = createFileRoute("/patio-canopy")({
  beforeLoad: () => {
    throw redirect({ to: "/pergola-covers", replace: true, statusCode: 301 });
  },
  component: () => null,
});
